import { observable, computed, action } from 'mobx';
import TableItemNotEmote from './TableItemNotEmote';
import StatsResponse from './StatsResponse';

class TableItemNotEmotes {
    @observable tableItems = [ new TableItemNotEmote() ];

    constructor(data = []) {
        this.tableItems = data.map(e => new TableItemNotEmote(e));
    }

    @action updateTableItemAmount(eventData) {
        const { name, amount, key } = eventData;


        const tableItem = this.tableItems.find(e => {
            // console.log('yo');
            return name === e.name || key === e.name
        }) || new TableItemNotEmote(eventData);

        tableItem.amount = tableItem.amount + amount;
    }
}

export default TableItemNotEmotes;



// WEBPACK FOOTER //
// ./src/app/models/TableItemNotEmotes.js